package core.extensions

import common.EColors
import csstype.Color

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 18.10.22
 * Author : marcusspors
 */

fun EColors.toColor(): Color {
    return Color(this.mHex)
}